import { useEffect } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";

import { useAuth } from "./use-auth";

export const useUnauthorizedRedirect = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const { pathname } = useLocation();
  useEffect(() => {
    if (isAuthenticated.loaded && !isAuthenticated.status)
      navigate(`/auth?callback=${pathname}`, {
        replace: true,
        viewTransition: true,
      });
  }, [isAuthenticated]);
};
